import React from 'react';


const BreakTime = (props) => {
    const { min, addToBreak } = props;

    return (
        <p className='rounded-full bg-slate-300 w-[40px] p-2 text-center flex justify-center' onClick={() => addToBreak(min)}><span>{min}</span>m</p>
    );
};

export default BreakTime;